import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { useMatch } from 'react-router-dom';
import { NumberValidation } from '../../../utils/validations';
import BreadCrumb from '../../../components/common/BreadCrumb';
import { deliveryType } from '../productInterface';
import { GlobalContext, handleError } from '../../../context/Provider';
import henceforthApi from '../../../utils/henceforthApi';
import Spinner from '../../../components/common/spinner';
import GoogleMapReact from 'google-map-react';
import commonArray from '../../../components/common/commonArray';
import { Button } from '../../../components/ui/button';
import { Truck, MapPin, Save, AlertCircle, Clock, Navigation } from 'lucide-react';

const NEXT_PUBLIC_GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
let userMarker: any = null;
let cityCircle: any = null;

const defaultProps = {
  center: {
    lat: -37.82168417163056,
    lng: 145.05854992101723,
  },
  zoom: 12,
};

const AddDelivery: React.FC = () => {
  const match = useMatch('product/:product_id/delivery/add');
  const { language_data, authState, loading, setLoading, authDispatch } = useContext(GlobalContext);

  const breadCrumbPath = [
    {
      name: `${language_data?.[authState.lang]?.common_home || 'Home'}`,
      url: `/`,
      active: '',
    },
    {
      name: `${language_data?.[authState.lang]?.common_product || 'Product'} ${language_data?.[authState.lang]?.common_list || 'List'
        }`,
      url: `/products/1`,
      active: '',
    },
    {
      name: `${language_data?.[authState.lang]?.common_product || 'Product'} ${language_data?.[authState.lang]?.common_deatil || 'Detail'
        }`,
      url: `/product/${match?.params.product_id}`,
      active: '',
    },
    {
      name: `${language_data?.[authState.lang]?.common_add || 'Add'} ${language_data?.[authState.lang]?.common_delivery || 'Delivery Area'
        }`,
      url: ``,
      active: 'not-allowed',
    },
  ];

  const [addDelivery, setAddDelivery] = useState<deliveryType>({
    location: '',
    lat: '',
    lng: '',
    deliveryTime: '',
    radius: '',
  } as deliveryType);

  const [radiusErr, setRadiusErr] = useState<string>('');
  const [locationErr, setLocationErr] = useState<string>('');
  const [deliveryErr, setDeliveryErr] = useState<string>('');
  const [onAddressChanged, setOnAddressChanged] = useState(defaultProps);
  const googleMapRef = useRef<any>(null);
  const placeInputRef = useRef<any>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === 'radius' && String(value).startsWith('0')) return;
    if (name === 'deliveryTime' && String(value).startsWith('0')) return;
    if (name === 'radius' && !NumberValidation(value) && !value.includes('.')) return;
    if (name === 'radius' && Number(value) > 12800) return;
    if (name === 'deliveryTime' && !NumberValidation(value)) return;
    if (name === 'deliveryTime' && Number(value) > 10) return;

    if (name === 'location') checkLocationEdit();
    else if (name === 'radius') setRadiusErr('');
    else if (name === 'deliveryTime') setDeliveryErr('');

    setAddDelivery((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const submitHanlder = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!addDelivery.radius && !addDelivery.location.trim() && !addDelivery.deliveryTime.trim()) {
      setRadiusErr(
        `${language_data?.[authState.lang]?.common_radius || 'Radius'} ${language_data?.[authState.lang]?.common_is || 'is'
        } ${language_data?.[authState.lang]?.common_required || 'required'}`
      );
      setLocationErr(
        `${language_data?.[authState.lang]?.common_location || 'Location'} ${language_data?.[authState.lang]?.common_is || 'is'
        } ${language_data?.[authState.lang]?.common_required || 'required'}`
      );
      setDeliveryErr(
        `${language_data?.[authState.lang]?.common_delivery || 'Delivery time'} ${language_data?.[authState.lang]?.common_is || 'is'
        } ${language_data?.[authState.lang]?.common_required || 'required'}`
      );
      return;
    }
    if (!addDelivery.location.trim()) {
      return setLocationErr(
        `${language_data?.[authState.lang]?.common_please || 'Please'} ${language_data?.[authState.lang]?.common_select || 'select'
        } ${language_data?.[authState.lang]?.common_nearest || 'nearest'} ${language_data?.[authState.lang]?.common_place || 'place'
        }`
      );
    }
    if (locationErr.trim()) {
      return setLocationErr(
        `${language_data?.[authState.lang]?.common_please || 'Please'} ${language_data?.[authState.lang]?.common_select || 'select'
        } ${language_data?.[authState.lang]?.common_location || 'location'} ${language_data?.[authState.lang]?.common_from || 'from'
        } ${language_data?.[authState.lang]?.common_search || 'search'} ${language_data?.[authState.lang]?.common_list || 'list'
        }`
      );
    }
    if (!addDelivery.radius) {
      return setRadiusErr(
        `${language_data?.[authState.lang]?.common_radius || 'Radius'} ${language_data?.[authState.lang]?.common_is || 'is'
        } ${language_data?.[authState.lang]?.common_required || 'required'}`
      );
    }
    if (!addDelivery.deliveryTime) {
      return setDeliveryErr(
        `${language_data?.[authState.lang]?.common_delivery || 'Delivery'} ${language_data?.[authState.lang]?.common_time || 'time'} ${language_data?.[authState.lang]?.common_is || 'is'
        } ${language_data?.[authState.lang]?.common_required || 'required'}`
      );
    }

    const items = {
      product_id: match?.params.product_id,
      radius: addDelivery.radius,
      address: addDelivery.location,
      lat: addDelivery.lat,
      lng: addDelivery.lng,
      delivery_time: addDelivery.deliveryTime,
      units: 'Km',
      language: 'ENGLISH',
    };

    setLoading(true);
    try {
      await henceforthApi.Product.addProductDetailsDynamically(
        commonArray.productOtherDetails[5],
        items
      );
      window.history.back();
    } catch (err) {
      handleError(err, 'active', authDispatch);
    } finally {
      setLoading(false);
    }
  };

  const onKeyDown = (keyEvent: React.KeyboardEvent) => {
    if (keyEvent.key === 'Enter') {
      keyEvent.preventDefault();
    }
  };

  const onGoogleApiLoaded = () => {
    initPlaceAPI();
  };

  const initPlaceAPI = () => {
    if (placeInputRef.current && (window as any).google?.maps?.places) {
      const autocomplete = new (window as any).google.maps.places.Autocomplete(
        placeInputRef.current
      );
      (window as any).google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const place = autocomplete.getPlace();
        const formatAddress = place.formatted_address;
        const address = place.address_components;
        const items: any = {};
        if (Array.isArray(address) && address.length > 0) {
          const zipIndex = address.findIndex((res: any) => res.types.includes('postal_code'));
          const administrativeAreaIndex = address.findIndex((res: any) =>
            res.types.includes('administrative_area_level_1', 'political')
          );
          const localityIndex = address.findIndex((res: any) =>
            res.types.includes('locality', 'political')
          );
          const countryIndex = address.findIndex((res: any) =>
            res.types.includes('country', 'political')
          );
          const premiseIndex = address.findIndex((res: any) =>
            res.types.includes('premise', 'street_number')
          );

          if (zipIndex > -1) items.pin_code = address[zipIndex].long_name;
          if (administrativeAreaIndex > -1)
            items.state = address[administrativeAreaIndex].long_name;
          if (localityIndex > -1) items.city = address[localityIndex].long_name;
          if (countryIndex > -1) items.country = address[countryIndex].long_name;
          if (premiseIndex > -1) items.apartment_number = address[premiseIndex].long_name;

          items.full_address = formatAddress;
          setAddDelivery((prev) => ({
            ...prev,
            location: items?.full_address
              ? items.full_address
              : `${items.city},${items.state},${items.country}`,
            lat: place.geometry?.location?.lat(),
            lng: place.geometry?.location?.lng(),
          }));
          setLocationErr('');
        }
      });
    }
  };

  const createMerker = (position: any, map: any, icon?: any) => {
    return new (window as any).google.maps.Marker({
      position,
      map,
      draggable: false,
      label: `Delivery area`,
      icon,
    });
  };

  const createCircle = (radius: number) => {
    return new (window as any).google.maps.Circle({
      strokeColor: '#1AA7DE',
      strokeOpacity: 0.85,
      strokeWeight: 2,
      fillColor: '#1AA7DE',
      fillOpacity: 0.2,
      map: googleMapRef.current.map_,
      center: userMarker.getPosition(),
      radius,
    });
  };

  const createRadius = async () => {
    if (!addDelivery.lat || !addDelivery.lng || !googleMapRef.current?.map_) return;
    const latlng = { lat: Number(addDelivery.lat), lng: Number(addDelivery.lng) };
    const position = new (window as any).google.maps.LatLng(latlng);
    if (userMarker) {
      userMarker.setMap(null);
    }
    if (cityCircle) {
      cityCircle.setMap(null);
    }
    const radius = addDelivery.radius ? Number(addDelivery.radius) * 1000 : 0;
    userMarker = createMerker(position, googleMapRef.current.map_);
    cityCircle = createCircle(radius);

    userMarker.addListener('dragend', async () => {
      cityCircle.setCenter(userMarker?.getPosition());
    });
    setOnAddressChanged({
      ...onAddressChanged,
      center: latlng,
      zoom: getZoomLevel(cityCircle),
    });
  };

  const getZoomLevel = (circle: any) => {
    let zoomLevel = 0;
    if (circle != null) {
      const radius = circle.getRadius();
      const scale = radius / 500;
      zoomLevel = 16 - Math.log(scale) / Math.log(2);
    }
    return zoomLevel - 0.4;
  };

  useEffect(() => {
    createRadius();
  }, [addDelivery.lat, addDelivery.lng, addDelivery.radius]);

  const checkLocationEdit = () => {
    if (addDelivery.location) {
      setLocationErr(
        `${language_data?.[authState.lang]?.common_please || 'Please'} ${language_data?.[authState.lang]?.common_select || 'select'
        } ${language_data?.[authState.lang]?.common_your || 'your'} ${language_data?.[authState.lang]?.common_address || 'address'
        } ${language_data?.[authState.lang]?.common_again || 'again'}`
      );
    } else {
      setLocationErr('');
    }
  };

  return (
    <Fragment>
      <BreadCrumb pathNameDeclare={breadCrumbPath} />

      <div className="w-full px-4 sm:px-6 lg:px-8 py-4 space-y-4">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-start">
          {/* Form Card */}
          <div className="lg:col-span-5 bg-white rounded-2xl border border-slate-200/80 shadow-xs p-4 sm:p-4 space-y-4">
            {/* Header */}
            <div className="flex items-center gap-3.5 pb-4 border-b border-slate-100">
              <div className="w-10 h-10 rounded-xl bg-sky-50 text-[#1AA7DE] flex items-center justify-center shrink-0 shadow-2xs">
                <Truck className="w-5 h-5" />
              </div>
              <div>
                <h2 className="text-base sm:text-lg font-bold text-slate-900 tracking-tight m-0">
                  {language_data?.[authState.lang]?.common_add || 'Add'}{' '}
                  {language_data?.[authState.lang]?.common_delivery || 'Delivery Area'}
                </h2>
                <p className="text-xs text-slate-500 font-medium m-0 mt-0.5">
                  Set service location, coverage radius, and estimated time
                </p>
              </div>
            </div>

            {/* Form */}
            <form onKeyDown={onKeyDown} onSubmit={submitHanlder} className="space-y-4">
              {/* Location Input */}
              <div className="space-y-1.5">
                <label className="block text-xs sm:text-sm font-bold text-slate-700 tracking-wide">
                  {language_data?.[authState.lang]?.common_location || 'Service Center / Location'}{' '}
                  <span className="text-rose-500">*</span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400">
                    <MapPin className="w-4 h-4" />
                  </div>
                  <input
                    ref={placeInputRef}
                    type="search"
                    name="location"
                    value={addDelivery.location}
                    onChange={handleChange}
                    placeholder={`${language_data?.[authState.lang]?.common_search || 'Search'} ${language_data?.[authState.lang]?.common_location || 'location'
                      }`}
                    className={`w-full pl-10 pr-4 py-2.5 rounded-xl border text-xs sm:text-sm font-medium transition-all focus:outline-none focus:ring-2 ${locationErr
                        ? 'border-rose-300 bg-rose-50/30 text-rose-900 focus:ring-rose-200 focus:border-rose-500'
                        : 'border-slate-200 bg-slate-50/50 hover:bg-white focus:bg-white text-slate-800 focus:ring-[#1AA7DE]/20 focus:border-[#1AA7DE]'
                      }`}
                  />
                </div>
                {locationErr && (
                  <div className="flex items-center gap-1.5 text-xs font-semibold text-rose-600 pt-1">
                    <AlertCircle className="w-3.5 h-3.5 shrink-0" />
                    <span>{locationErr}</span>
                  </div>
                )}
              </div>

              {/* Radius Input */}
              <div className="space-y-1.5">
                <label className="block text-xs sm:text-sm font-bold text-slate-700 tracking-wide">
                  {language_data?.[authState.lang]?.common_radius || 'Radius (Km)'}{' '}
                  <span className="text-rose-500">*</span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400">
                    <Navigation className="w-4 h-4" />
                  </div>
                  <input
                    type="text"
                    name="radius"
                    value={addDelivery.radius}
                    onChange={handleChange}
                    placeholder="e.g. 15"
                    className={`w-full pl-10 pr-4 py-2.5 rounded-xl border text-xs sm:text-sm font-medium transition-all focus:outline-none focus:ring-2 ${radiusErr
                        ? 'border-rose-300 bg-rose-50/30 text-rose-900 focus:ring-rose-200 focus:border-rose-500'
                        : 'border-slate-200 bg-slate-50/50 hover:bg-white focus:bg-white text-slate-800 focus:ring-[#1AA7DE]/20 focus:border-[#1AA7DE]'
                      }`}
                  />
                </div>
                {radiusErr && (
                  <div className="flex items-center gap-1.5 text-xs font-semibold text-rose-600 pt-1">
                    <AlertCircle className="w-3.5 h-3.5 shrink-0" />
                    <span>{radiusErr}</span>
                  </div>
                )}
              </div>

              {/* Delivery Time Input */}
              <div className="space-y-1.5">
                <label className="block text-xs sm:text-sm font-bold text-slate-700 tracking-wide">
                  {language_data?.[authState.lang]?.common_delivery || 'Delivery Time'}{' '}
                  <span className="text-slate-400 font-normal">
                    ({language_data?.[authState.lang]?.common_time || 'Days/Hours'})
                  </span>{' '}
                  <span className="text-rose-500">*</span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400">
                    <Clock className="w-4 h-4" />
                  </div>
                  <input
                    type="text"
                    name="deliveryTime"
                    maxLength={2}
                    value={addDelivery.deliveryTime}
                    onChange={handleChange}
                    placeholder="e.g. 2"
                    className={`w-full pl-10 pr-4 py-2.5 rounded-xl border text-xs sm:text-sm font-medium transition-all focus:outline-none focus:ring-2 ${deliveryErr
                        ? 'border-rose-300 bg-rose-50/30 text-rose-900 focus:ring-rose-200 focus:border-rose-500'
                        : 'border-slate-200 bg-slate-50/50 hover:bg-white focus:bg-white text-slate-800 focus:ring-[#1AA7DE]/20 focus:border-[#1AA7DE]'
                      }`}
                  />
                </div>
                {deliveryErr && (
                  <div className="flex items-center gap-1.5 text-xs font-semibold text-rose-600 pt-1">
                    <AlertCircle className="w-3.5 h-3.5 shrink-0" />
                    <span>{deliveryErr}</span>
                  </div>
                )}
              </div>

              {/* Action Buttons */}
              <div className="flex items-center justify-end gap-2.5 pt-4 border-t border-slate-100">
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  onClick={() => window.history.back()}
                  disabled={loading}
                >
                  {language_data?.[authState.lang]?.common_cancel || 'Cancel'}
                </Button>
                <Button
                  type="submit"
                  variant="default"
                  size="sm"
                  disabled={loading}
                  className="gap-1.5"
                >
                  {loading ? (
                    <Spinner color="text-white" />
                  ) : (
                    <>
                      <Save className="w-4 h-4" />
                      <span>{language_data?.[authState.lang]?.common_save || 'Save Delivery'}</span>
                    </>
                  )}
                </Button>
              </div>
            </form>
          </div>

          {/* Map Preview Card */}
          <div className="lg:col-span-7 bg-white rounded-2xl border border-slate-200/80 shadow-xs p-3 overflow-hidden h-[450px] lg:h-[550px]">
            <div className="w-full h-full rounded-xl overflow-hidden relative">
              <GoogleMapReact
                ref={googleMapRef}
                bootstrapURLKeys={{
                  key: String(NEXT_PUBLIC_GOOGLE_API_KEY || ''),
                  libraries: ['places'],
                }}
                defaultCenter={defaultProps.center}
                center={onAddressChanged.center}
                zoom={onAddressChanged.zoom}
                defaultZoom={defaultProps.zoom}
                onGoogleApiLoaded={onGoogleApiLoaded}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddDelivery;